let React                = require("react");

let ContentServerClient  = require("../../ContentServerClient.js");
let qwebchannel          = require("qwebchannel").QWebChannel;
let CircuitsUtil         = require("../../util/CircuitsUtil.js");
let UnitConversions = require("../../cio-config/unitConversions.js");

let Menu                 = require("./Menu.jsx");
let SearchBox            = require("../../controls/search/SearchBox.jsx");
let Header               = require("./Header.jsx");
let QtsearchCard         = require("../../controls/cards/QtsearchCard.jsx");

const NUMROWS = 50;

class SearchPackages extends React.Component {
    
    constructor(){
        super();
        
        this.state = { currentView: "infoPublic", layout: "list", sort: "updated_at%20desc",
        infoPublic: { show: true, items: [], total: 0, page: 1},
        infoPrivate: { show: false, items: [], total: 0, page: 1}}
        
        this.infoPublicQuery = "";
        this.infoPrivateQuery = "";
        
        this.onSort = this.onSort.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.downloadItem = this.downloadItem.bind(this);
        this.onChangeList = this.onChangeList.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
    }

    componentDidMount(){
        this.loadChannel(qwebchannel);
        let {queryHub, hubReceived, privateEndpoint} = this.getQueryHub(this.props.location.search) 
        this.setState({queryHub, hubReceived, privateEndpoint},
                () => {
                    this.getItems({filter: `hasVersions=true&private=false&q=""`});
                    this.getItems({filter: `hasVersions=true&${this.state.queryHub}`, type: "infoPrivate"});
                    window.addEventListener('scroll', this.onScroll);
                })
    }

    componentWillUnmount(){
        window.removeEventListener('scroll', this.onScroll);
    }

    loadChannel(qwebchannel){
        try {
            const { qt: { webChannelTransport }} = window;
            new qwebchannel(webChannelTransport, channel => this.AddAsset = channel.objects.QtAssetAdder.AddAsset);
        } catch(error){
                //alert(error);
                console.error(error);
        }
    }

    onChangeList(){
        let layout = this.state.layout === "list"? "grid": "list";
        this.setState({ layout })
    }
    
    onChangeView(currentView){
        this.setState({ currentView })
    }

    onSort(sort){
        this.setState({ sort }, () => {this.getItems({filter: this.infoPublicQuery, sort});
                                        this.getItems({filter: this.infoPrivateQuery, sort, type: "infoPrivate"}) });
    }

    onSearch({url}){
        let { infoPublic, infoPrivate } = this.state;
        infoPublic.page = infoPrivate.page = 1;
        this.setState({ infoPublic, infoPrivate },
            () => {
                if(url === "q="){url = `q=""`};
                this.getItems({filter: `${url}&private=false`});
                this.getItems({filter: `${url}&${this.state.queryHub}`, type: "infoPrivate"})});
    }

    downloadItem(assetType, assetId, version = 1){
        try{
            this.AddAsset({assetType, assetId, version});
        }catch(error){
            //alert(error)
            console.error(error)
        }
    }

    getItems({ filter, type = "infoPublic", start=0, rows=NUMROWS}){
        let endpoint = "explore/packages";
        if(type === "infoPublic"){ 
            this.infoPublicQuery = filter;
        }else{ 
            this.infoPrivateQuery = filter;
            endpoint = this.state.privateEndpoint;
        }
        const { sort, [type]:{ page } } = this.state;
        ContentServerClient.getFile(endpoint, `${filter}&start=${start}&rows=${rows}&sort=${sort}`)
            .then(items => this.setState({[type]: {items: items.results, total: items.numberOfResults, page}}))
    }

    onScroll(){
        const { innerHeight, scrollY } = window;
        const { body: {clientHeight} } = document;


        if(scrollY >= clientHeight - innerHeight){
            const { currentView, [currentView]: { page, total } } = this.state;
            const totalPages = Math.ceil(total / NUMROWS);
            const start = page * NUMROWS;

            if(page <= totalPages){
                let filter = currentView === "infoPublic"? this.infoPublicQuery: this.infoPrivateQuery;
                this.addItems({filter, start, type: currentView});
            }
        }
    }

    addItems({filter, type = "infoPublic", start, rows=NUMROWS}){
        let endpoint = "explore/packages";
        let { sort, [type]:{ page, items: oldItems }, privateEndpoint} = this.state;
        ++page;
        if(type === "infoPrivate"){ endpoint = privateEndpoint }
        ContentServerClient.getFile(endpoint, `${filter}&start=${start}&rows=${rows}&sort=${sort}`)
            .then(items => this.setState({[type]: {items: [...oldItems, ...items.results], total: items.numberOfResults, page}}))
            .catch(this.handleError);
    }

    convert(value){
        if(!value){ return false };
        return `${UnitConversions.Micrometers.toMillimeters(value).toFixed(2)} mm`;
    }

    getQueryHub(location) {
        if(!location.includes("hub=")) return {queryHub: "", hubReceived: false, privateEndpoint: "packages/mine"};

        let isFinded = false;
        return location.replace("?", "").split("&")
                    .reduce((acc, cur) => {
                        if(!isFinded && cur.includes("hub") && cur.length > 4){
                            acc = {queryHub: cur, hubReceived: true, privateEndpoint: "packages"};
                            isFinded = true;
                        }
                        return acc; 
                    }, {queryHub: "", hubReceived: false, privateEndpoint: "packages/mine"});
    }

    render() {
        const { infoPublic, infoPrivate, currentView, layout, hubReceived} = this.state;
        let isList = layout === "list"? true: false;
        let isPublic = currentView === "infoPublic";
        let items = isPublic ? infoPublic.items : infoPrivate.items;
        let total = isPublic ? infoPublic.total : infoPrivate.total; 

        return (
            <div className="searchPackages">
                <Menu onSearch={this.onSearch} 
                      onChangeView={this.onChangeView} onChangeList={this.onChangeList}/>
                
                <div className="searchPackages__separator"></div>

                <SearchBox onSetUrlLibraries={this.onSearch} onRemove={this.onRemove}/>

                {isList && <Header total={total} onSort={this.onSort}/>}
                
                <div className={`searchPackages__content cards -package  -${layout}`}>
                    {items.map(item => {
                        return <QtsearchCard key={item.id} 
                                    layout={layout} 
                                    resource={item}
                                    showOwner={isPublic || !hubReceived}
                                    action={() => this.downloadItem("package", item.id, CircuitsUtil.getMostRecentVersion(item))}
                                >
                                {({layout, properties}) => {
                                    if(layout === "list"){
                                        return <div className="card__properties flex">
                                                <div className="card__properties__name">{properties.pins || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.pitch) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.pitch2) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.body_length) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.body_width) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.height) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.lead_span) || "n/a"}</div>
                                                <div className="card__properties__name">{this.convert(properties.lead_span2) || "n/a"}</div>
                                            </div>
                                    }else{ return null }
                                }}
                                </QtsearchCard>
                    })}
                </div>
            </div>
        );
    }
}

module.exports = SearchPackages;
